import { useEffect } from 'react';

import { useLocation, useHistory } from 'react-router-dom';

import {
  ONLINE_CONTENT_CONNECTOR_ATTRIBUTES,
  useOnlineContentConnector,
} from '../../context/OnlineContentConnectorContext';

const useOnlineContentConnectorParams = () => {
  const prevLocation = useLocation();
  const history = useHistory();

  const { updateData } = useOnlineContentConnector();

  useEffect(() => {
    if (history) {
      const unlisten = history.listen((currLocation) => {
        const isDifferentRoute =
          prevLocation.search !== currLocation.search ||
          prevLocation.pathname !== currLocation.pathname;
        let hadParams = false;
        let hasParams = false;

        ONLINE_CONTENT_CONNECTOR_ATTRIBUTES.forEach((item) => {
          if (prevLocation.search.includes(item)) {
            hadParams = true;
          }
          if (currLocation.search.includes(item)) {
            hasParams = true;
          }
        });

        if (hadParams && !hasParams && isDifferentRoute) {
          const prevSearchParams = new URLSearchParams(prevLocation.search);
          const currSearchParams = new URLSearchParams(currLocation.search);

          ONLINE_CONTENT_CONNECTOR_ATTRIBUTES.forEach((item) => {
            let param = prevSearchParams.get(item);
            if (param) {
              currSearchParams.append(item, param);
            }
          });

          const stringifiedParams = currSearchParams.toString();
          history.replace(currLocation.pathname + stringifiedParams ? '?' + stringifiedParams : '');
        }
      });

      return () => unlisten();
    }
  }, [history, prevLocation]);

  useEffect(() => {
    const searchParams = new URLSearchParams(prevLocation?.search);
    const onlineContentConnectorData = {};
    ONLINE_CONTENT_CONNECTOR_ATTRIBUTES.forEach((key) => {
      const val = searchParams.get(key);
      if (val) {
        onlineContentConnectorData[key] = val;
      }
    });

    if (Object.keys(onlineContentConnectorData).length > 0) {
      updateData(onlineContentConnectorData);
    }
  }, [prevLocation, updateData]);
};

export default useOnlineContentConnectorParams;
